import React from 'react';
import DefaultTabItem, { type GxPDefaultTab } from './DefaultTabItem';
import '../../GxP.scss';
import type { GxPReportTabCounts, GxPReportTabKey } from '../types';

const GXP_DEFAULT_TABS: GxPDefaultTab[] = [
  { id: 'all', label: 'All' },
  { id: 'to_review', label: 'To review' },
  { id: 'published', label: 'Published' },
  { id: 'sent', label: 'Sent' },
];

interface Props {
  activeTabId: GxPReportTabKey;
  tabCounts: GxPReportTabCounts;
  onTabChange: (tabId: GxPReportTabKey) => void;
}

const GxPTabStrip: React.FC<Props> = ({
  activeTabId,
  tabCounts,
  onTabChange,
}) => {
  return (
    <div data-testid='gxp-tab-strip' role='tablist' className='gxp-tab-strip'>
      {GXP_DEFAULT_TABS.map((tab) => (
        <DefaultTabItem
          key={tab.id}
          tab={tab}
          isActive={activeTabId === tab.id}
          recordCount={tabCounts[tab.id]}
          onClick={() => onTabChange(tab.id)}
        />
      ))}
    </div>
  );
};

export default GxPTabStrip;
